if (!customElements.get("video-reels")) {
  customElements.define(
    "video-reels",
    class VideoReels extends HTMLElement {
      constructor() {
        super();
        this.activeClass = "active";
        this.swiper = this.querySelector(".wt-slider__container");
        this.isHovering = false;
        this.watchdogInterval = null;
      }

      connectedCallback() {
        this.init();
      }

      isMobile() {
        return window.innerWidth < 900;
      }

      updateAllVideosSound(swiper) {
        const soundOn = swiper.el.dataset.sound === "on";
        swiper.slides.forEach((slide) => {
          const video = slide.querySelector("video");
          if (video) video.muted = !soundOn;
        });
      }

      observeSection(swiper) {
        const sectionObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                this.pasueAllVideos();
              } else if (this.isMobile()) {
                this.playVideoInActiveSlide(swiper);
              }
            });
          },
          { root: null, rootMargin: "0px", threshold: 0.1 },
        );
        sectionObserver.observe(this);
      }

      handleSoundToggle(swiper) {
        swiper.slides.forEach((slide) => {
          const button = slide.querySelector(".wt-video__sound-toggle");
          const video = slide.querySelector("video");
          const that = this;
          button.addEventListener("click", function () {
            if (!video) return;
            video.muted = !video.muted;
            swiper.el.dataset.sound = video.muted ? "off" : "on";
            that.updateAllVideosSound(swiper);
          });
        });
      }

      pasueAllVideos() {
        this.querySelectorAll("video").forEach((v) => v.pause());
      }

      playVideoInActiveSlide(swiper) {
        const activeSlide = swiper.slides[swiper.activeIndex];
        if (!activeSlide) return;
        const video = activeSlide.querySelector("video");
        if (video) video.play();
      }

      findActiveSlide(swiper) {
        return swiper.slides[swiper.activeIndex];
      }

      toggleActiveClass(swiper) {
        const activeSlide = this.findActiveSlide(swiper);
        swiper.slides.forEach((slide) => {
          slide.classList.remove(this.activeClass);
          if (activeSlide === slide) slide.classList.add(this.activeClass);
        });
      }

      handleSlideChange(swiper) {
        if (!this.isHovering) this.pasueAllVideos();
        this.toggleActiveClass(swiper);
        if (this.isMobile()) this.playVideoInActiveSlide(swiper);
      }

      addVideoEventHandlers(swiper) {
        const that = this;
        swiper.on("slideChange", (swp) => that.handleSlideChange(swp));
        swiper.on("slideChangeTransitionEnd", (swp) => that.handleSlideChange(swp));
      }

      // Desktop only
      addHoverVideoHandlers(swiper) {
        this.querySelectorAll("[data-swiper-slide]").forEach((slide) => {
          const video = slide.querySelector("video");

          slide.addEventListener("mouseenter", () => {
            this.isHovering = true;
            swiper.autoplay.stop();
            const idx = swiper.slides.indexOf(slide);
            if (idx !== -1) {
              const currentTranslate = swiper.getTranslate();
              const targetTranslate = -(swiper.slidesGrid[idx] || 0);
              const pixelDistance = Math.abs(targetTranslate - currentTranslate);
              const slideWidth = (swiper.slidesSizesGrid[0] || 300) + swiper.params.spaceBetween;
              const slideDistance = pixelDistance / slideWidth;
              const duration = Math.max(800, Math.min(2500, slideDistance * 350));
              swiper.slideTo(idx, duration);
            }
            if (video) video.play();
          });

          slide.addEventListener("mouseleave", () => {
            if (video) video.pause();
          });
        });
      }

      // Desktop only
      addContainerHoverHandlers(swiper) {
        const container = this.querySelector(".wt-slider__container");

        container.addEventListener("mouseleave", () => {
          this.isHovering = false;
          this.pasueAllVideos();
          setTimeout(() => {
            if (this.isHovering) return;
            swiper.slideTo(swiper.activeIndex, 0, false);
            requestAnimationFrame(() => {
              if (!this.isHovering) {
                swiper.setTransition(swiper.params.speed);
                swiper.autoplay.start();
              }
            });
          }, 50);
        });
      }

      // Desktop only
      startAutoplayWatchdog(swiper) {
        this.watchdogInterval = setInterval(() => {
          if (!this.isHovering && swiper.autoplay && !swiper.autoplay.running && !swiper.autoplay.paused) {
            swiper.autoplay.start();
          }
        }, 1000);
      }

      initMobile(swiper) {
        swiper.params.speed = 300;
        if (swiper.params.loop) {
          swiper.loopDestroy();
          swiper.params.loop = false;
          swiper.update();
        }
        this.playVideoInActiveSlide(swiper);
      }

      initDesktop(swiper) {
        this.addHoverVideoHandlers(swiper);
        this.addContainerHoverHandlers(swiper);
        this.startAutoplayWatchdog(swiper);
      }

      checkSwiperInitialization() {
        const swiperContainer = this.swiper;
        const mySwiperInstance = swiperContainer.swiper;

        if (swiperContainer.classList.contains("swiper-initialized")) {
          this.addVideoEventHandlers(mySwiperInstance);
          this.handleSoundToggle(mySwiperInstance);
          this.observeSection(mySwiperInstance);

          if (this.isMobile()) {
            this.initMobile(mySwiperInstance);
          } else {
            this.initDesktop(mySwiperInstance);
          }

          clearInterval(this.checkInterval);
        }
      }

      init() {
        this.checkInterval = setInterval(
          this.checkSwiperInitialization.bind(this),
          500,
        );
      }
    },
  );
}
